// BillFromForm.js - Added Document ID field (CIF, NIF, Passport number)
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

const BillFromForm = ({ billFrom, billFromEmail, billFromAddress, billFromDocumentId, editField }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Form.Label className="fw-bold" htmlFor="bill-from">{t('billFrom')}</Form.Label>
      
      <Form.Group className="mb-2">
        <Form.Control
          placeholder={t('billFromPlaceholder')}
          value={billFrom}
          type="text"
          name="billFrom"
          onChange={editField}
          autoComplete="name"
          required
        />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Control
          placeholder={t('documentIdPlaceholder')}
          value={billFromDocumentId}
          type="text"
          name="billFromDocumentId"
          onChange={editField}
          autoComplete="off"
        />
      </Form.Group>
      
      <Form.Group className="mb-2">
        <Form.Control
          placeholder={t('emailPlaceholder')}
          value={billFromEmail}
          type="email"
          name="billFromEmail"
          onChange={editField}
          autoComplete="email"
          required
        />
      </Form.Group>
      
      <Form.Group className="mb-2">
        <Form.Control
          as="textarea"
          rows={2}
          placeholder={t('addressPlaceholder')}
          value={billFromAddress}
          name="billFromAddress"
          onChange={editField}
          autoComplete="address"
          required
          style={{ resize: 'vertical' }} // Optional: allows vertical resize only
        />
      </Form.Group>

    </div>
  );
};

export default BillFromForm;